import { PayerType } from 'list-types-public';
import { environment } from '../environment/environment';

/**
 * One selectable payer bucket. `id` is the raw `listPayerType` value stored on
 * the referral — deliberately a plain string, not PayerType: a client's
 * payer-type mapping is uploaded as free-form {label, type} records and is not
 * constrained to the enum (see the CCARECT list below).
 */
export interface PayerTypeFilterOption {
  label: string;
  id: string;
}

const STANDARD_OPTIONS: PayerTypeFilterOption[] = [
  { label: 'Medicare', id: PayerType.Medicare },
  { label: 'HMO', id: PayerType.Hmo },
  { label: 'Other', id: PayerType.Other },
];

const CCARECT_OPTIONS: PayerTypeFilterOption[] = [
  { label: 'Medicare', id: 'Medicare' },
  { label: 'Medicaid', id: 'Medicaid' },
  { label: 'HMO', id: PayerType.Hmo },
  { label: 'Commercial', id: 'Commercial' },
  { label: 'Pending Medicaid', id: 'Pending Medicaid' },
  { label: 'Auto insurance', id: 'Auto insurance' },
  { label: 'Vet', id: 'Vet' },
  { label: 'Workers comp', id: 'Workers comp' },
  { label: 'VA', id: 'VA' },
  { label: PayerType.Other, id: PayerType.Other },
  { label: 'No payer', id: 'No payer' },
];

function resolvePayerTypeFilterOptions(): PayerTypeFilterOption[] {
  const { snfClient, CLIENTS_NAMES } = environment;
  if (snfClient === CLIENTS_NAMES.CCARECT) return CCARECT_OPTIONS;
  if (
    snfClient === CLIENTS_NAMES.EMPIRE ||
    snfClient === CLIENTS_NAMES.CCARE ||
    snfClient === CLIENTS_NAMES.SUMMITCARE
  ) {
    return STANDARD_OPTIONS;
  }
  // Clients with no payer-type mapping uploaded: every referral resolves to
  // Other, so the filter would only ever be noise. Surfaces are expected to
  // hide the control entirely rather than show a one-value dropdown.
  return [];
}

/** Payer buckets this client can filter on; empty when the client has no mapping. */
export const PAYER_TYPE_FILTER_OPTIONS: ReadonlyArray<PayerTypeFilterOption> = resolvePayerTypeFilterOptions();

/** Just the ids — used to drop unknown values read back out of storage. */
export const PAYER_TYPE_FILTER_IDS: readonly string[] = PAYER_TYPE_FILTER_OPTIONS.map(option => option.id);
